'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _Analytics = require('../../../Analytics');

var _Analytics2 = _interopRequireDefault(_Analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2018 New Vector Ltd.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var CookieBar = function (_React$Component) {
    (0, _inherits3.default)(CookieBar, _React$Component);

    function CookieBar() {
        (0, _classCallCheck3.default)(this, CookieBar);
        return (0, _possibleConstructorReturn3.default)(this, (CookieBar.__proto__ || (0, _getPrototypeOf2.default)(CookieBar)).call(this));
    }

    (0, _createClass3.default)(CookieBar, [{
        key: 'onUsageDataClicked',
        value: function onUsageDataClicked(e) {
            e.stopPropagation();
            e.preventDefault();
            _Analytics2.default.showDetailsModal();
        }
    }, {
        key: 'onAccept',
        value: function onAccept() {
            _dispatcher2.default.dispatch({
                action: 'accept_cookies'
            });
        }
    }, {
        key: 'onReject',
        value: function onReject() {
            _dispatcher2.default.dispatch({
                action: 'reject_cookies'
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            var toolbarClasses = "mx_MatrixToolbar";
            return _react2.default.createElement(
                'div',
                { className: toolbarClasses },
                _react2.default.createElement('img', { className: 'mx_MatrixToolbar_warning', src: require("../../../../res/img/warning.svg"), width: '24', height: '23', alt: '' }),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_MatrixToolbar_content' },
                    this.props.policyUrl ? (0, _languageHandler._t)("Please help improve Riot.im by sending <UsageDataLink>anonymous usage data</UsageDataLink>. " + "This will use a cookie " + "(please see our <PolicyLink>Cookie Policy</PolicyLink>).", {}, {
                        'UsageDataLink': function UsageDataLink(sub) {
                            return _react2.default.createElement(
                                'a',
                                {
                                    className: 'mx_MatrixToolbar_link',
                                    onClick: _this2.onUsageDataClicked
                                },
                                sub
                            );
                        },
                        // XXX: We need to link to the page that explains our cookies
                        'PolicyLink': function PolicyLink(sub) {
                            return _react2.default.createElement(
                                'a',
                                {
                                    className: 'mx_MatrixToolbar_link',
                                    target: '_blank',
                                    href: _this2.props.policyUrl
                                },
                                sub
                            );
                        }

                    }) : (0, _languageHandler._t)("Please help improve Riot.im by sending <UsageDataLink>anonymous usage data</UsageDataLink>. " + "This will use a cookie.", {}, {
                        'UsageDataLink': function UsageDataLink(sub) {
                            return _react2.default.createElement(
                                'a',
                                {
                                    className: 'mx_MatrixToolbar_link',
                                    onClick: _this2.onUsageDataClicked
                                },
                                sub
                            );
                        }
                    })
                ),
                _react2.default.createElement(
                    AccessibleButton,
                    { element: 'button', className: 'mx_MatrixToolbar_action', onClick: this.onAccept },
                    (0, _languageHandler._t)("Yes, I want to help!")
                ),
                _react2.default.createElement(
                    AccessibleButton,
                    { className: 'mx_MatrixToolbar_close', onClick: this.onReject },
                    _react2.default.createElement('img', { src: require("../../../../res/img/cancel.svg"), width: '18', height: '18', alt: (0, _languageHandler._t)('Close') })
                )
            );
        }
    }]);
    return CookieBar;
}(_react2.default.Component);

CookieBar.propTypes = {
    policyUrl: _propTypes2.default.string
};
exports.default = CookieBar;
module.exports = exports['default'];
//# sourceMappingURL=CookieBar.js.map